import Layout from 'Nori/Layout';
import ItemBreakpoint from 'Custom/ItemBreakpoint';
import FAQWrapper from 'Custom/FAQ/FAQWrapper';
import { Finder } from 'Custom/Finder';
import HeroFull from 'Nori/Hero/HeroFull';
import RichText from 'Custom/RichText';
import HERO_BG_IMAGE from 'Images/background/half-pink-marble.png';
import HERO_BG_IMAGE_MOBILE from 'Images/background/half-pink-marble-mobile.png';
import styles from 'styles/pages/questions.module.scss';
import { FAQ_EXPLORING_QUESTIONS, FAQ_NEXPLANON_USERS } from 'Utils/questions';

const HEAD = {
  title:
    'Frequently Asked Questions About NEXPLANON® (etonogestrel implant) 68 mg Radiopaque',
  description:
    'Review the most frequently asked questions about NEXPLANON® (etonogestrel implant) 68 mg Radiopaque—from insertion and removal to effectiveness and side effects.',
  keywords:
    'Does Nexplanon Stop Periods, How long does Nexplanon last, How does Nexplanon Work, Nexplanon FAQs',
};

export default function Questions() {
  const HeroBannerContent = () => (
    <div className={styles['content-wrap']} data-qa-tag="content-wrap-faq">
      <RichText data-qa-tag="richtext-faq-section">
        <div
          className={styles.pregnancyAfterNexplanonPage}
          data-qa-tag="faq-page-wrapper"
        >
          <h4 data-qa-tag="heading-faq">FAQ</h4>

          <div
            className={styles.middleHeroText}
            data-qa-tag="faq-middle-hero-text"
          >
            the most commonly asked questions about Nexplanon
          </div>

          <p
            className={styles.bottomHeroText}
            data-qa-tag="faq-bottom-hero-text"
          >
            And, of course, answers to those questions.
          </p>
        </div>
      </RichText>
    </div>
  );

  return (
    <Layout head={HEAD}>
      <div className={styles.heroWrapper} data-qa-tag="hero-wrapper-faq">
        <ItemBreakpoint
          breakpoint={'lg'}
          data-qa-tag="item-breakpoint-faq-hero"
        >
          <HeroFull
            image={HERO_BG_IMAGE}
            data-design-visible="visible_vd"
            data-design-type="module"
            data-design-nori_id="Hero"
            data-design-module_name="NEXPLANON: FAQS"
            data-design-module_no="01"
            data-qa-tag="hero-full-desktop-faq"
          >
            <HeroBannerContent data-qa-tag="hero-banner-content-desktop-faq" />
          </HeroFull>

          <HeroFull
            image={HERO_BG_IMAGE_MOBILE}
            data-design-visible="visible_vd"
            data-design-type="module"
            data-design-nori_id="Hero"
            data-design-module_name="NEXPLANON: FAQS"
            data-design-module_no="01"
            data-qa-tag="hero-full-mobile-faq"
          >
            <HeroBannerContent data-qa-tag="hero-banner-content-mobile-faq" />
          </HeroFull>
        </ItemBreakpoint>
      </div>

      <FAQWrapper
        className={styles.firstAccordion}
        title={'Exploring NEXPLANON'}
        questions={FAQ_EXPLORING_QUESTIONS}
        moduleNumber="02"
      />

      <FAQWrapper
        title={'Using NEXPLANON'}
        questions={FAQ_NEXPLANON_USERS}
        moduleNumber="03"
        className={styles.secondAccordion}
        whiteColoredborder={true}
      />

      <Finder data-design-module_no="04" data-qa-tag="finder-component" />
    </Layout>
  );
}
